import React from "react";
import { Route, Routes } from "react-router-dom";
import Agencies from "../app/AdminViews/Agencies";
import AddAgency from "../app/AdminViews/Agencies/AddAgency";
import AgencyProfile from "../app/AdminViews/Agencies/AgencyProfile";
import AddAgent from "../app/AdminViews/Agents/AddAgent";
import AgentProfile from "../app/AdminViews/Agents/AgentProfile";
import Agents from "../app/AdminViews/Agents/Agents";
import Commissions from "../app/AdminViews/Commisions";
import Configurations from "../app/AdminViews/Configurations";
import AddCharge from "../app/AdminViews/Configurations/Charges/AddCharge";
import AddCommissionConfiguration from "../app/AdminViews/Configurations/Commissions/AddCommissionConfiguration";
import AddRate from "../app/AdminViews/Configurations/Rates/AddRate";
import Dashboard from "../app/AdminViews/Dashboard";
import FundingStatement from "../app/AdminViews/FundingStatement";
import Receivers from "../app/AdminViews/Receivers";
import ReceiverProfile from "../app/AdminViews/Receivers/ReceiverProfile";
import Senders from "../app/AdminViews/Senders";
import SenderProfile from "../app/AdminViews/Senders/SenderProfile";
import Settings from "../app/AdminViews/Settings";
import Staff from "../app/AdminViews/Staff";
import AddStaff from "../app/AdminViews/Staff/AddStaff";
import Transactions from "../app/AdminViews/Transactions";
import TransactionReceipt from "../app/AgentViews/Transactions/TransactionReceipt.jsx";
import TransactionHistory from "../app/AgentViews/TransactionsHistory";
import PageNotFound from "./404Page";
import AddNewReceiverComp from "./common/AddNewReceiver";
import AddNewSender from "./common/AddNewSender";
const AdminRoutes = ({ setShowSidebar, setShowNavbar }) => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/transaction-history" element={<TransactionHistory />} />
      <Route path="/transaction/:id" element={<TransactionReceipt />} />
      {/* <Route path="/transaction/:id" element={<Receipt />} /> */}
      <Route path="/revenue" element={<Commissions />} />
      <Route path="/add-agent" element={<AddAgent />} />
      <Route path="/add-sender" element={<AddNewSender />} />
      <Route path="/add-receiver" element={<AddNewReceiverComp />} />
      <Route path="/agencies" element={<Agencies />} />
      <Route path="/agents" element={<Agents />} />
      <Route path="/agent/:id" element={<AgentProfile />} />
      <Route path="/agency/:id" element={<AgencyProfile />} />
      {/* <Route path="/agent/:id" element={<Agent />} /> */}
      <Route path="/senders" element={<Senders />} />
      <Route path="/receivers" element={<Receivers />} />
      <Route path="/sender/:id" element={<SenderProfile />} />
      {/* <Route path="/sender/:id" element={<Sender />}/> */}
      <Route path="/receiver/:id" element={<ReceiverProfile />} />
      {/* <Route path="/receiver/:id" element={<Receiver />} /> */}
      <Route path="/settings" element={<Settings />} />
      <Route path="/staff" element={<Staff />} />
      <Route path="/add-staff" element={<AddStaff />} />
      <Route path="/add-agency" element={<AddAgency />} />
      <Route path="/add-rate" element={<AddRate />} />
      <Route path="/add-charge" element={<AddCharge />} />
      <Route
        path="/commission-config"
        element={<AddCommissionConfiguration />}
      />
      <Route path="/configurations" element={<Configurations />} />
      <Route path="/commissions/:type/:id" element={<Commissions />} />
      <Route path="/statement/:type/:id" element={<FundingStatement />} />
      <Route
        path="*"
        element={
          <PageNotFound
            setShowSidebar={setShowSidebar}
            setShowNavbar={setShowNavbar}
          />
        }
      />
    </Routes>
  );
};

export default AdminRoutes;
